import React from "react";
import { Link } from "react-router-dom";
import { Breadcrumbs } from "../../assets/svg";

const Breadcrumb = ({
  breadCrumbTitle,
  breadCrumbParent,
  breadCrumbParent2,
  breadCrumbParent3,
  breadCrumbActive,
  breadCrumbTitleKey,
  breadCrumbParentKey,
  breadCrumbParentKey2,
  breadCrumbParentKey3,
  breadCrumbActiveKey,
  classes,
}) => {
  return (
    <div className="w-full">
      <ul
        className={`flex items-center gap-x-2 whitespace-nowrap overflow-x-auto scrollbar-hide px-1 ${classes}`}
      >
        {/* Parent 1 */}
        {breadCrumbParent && (
          <li className="shrink-0">
            <Link
              to={breadCrumbTitleKey || "#"}
              className="text-textSecondary text-sm md:text-base font-Proxima"
            >
              {breadCrumbParent}
            </Link>
          </li>
        )}

        {/* Parent 2 */}
        {breadCrumbParent2 && (
          <li className="flex items-center gap-x-2 shrink-0">
            <Breadcrumbs size="16" />
            <Link
              to={breadCrumbParentKey2 || "#"}
              className="text-textSecondary text-sm md:text-base font-Proxima"
            >
              {breadCrumbParent2}
            </Link>
          </li>
        )}

        {/* Parent 3 */}
        {breadCrumbParent3 && (
          <li className="flex items-center gap-x-2 shrink-0">
            <Breadcrumbs size="16" />
            <Link
              to={breadCrumbParentKey3 || "#"}
              className="text-textSecondary text-sm md:text-base font-Proxima"
            >
              {breadCrumbParent3}
            </Link>
          </li>
        )}

        {/* Active Item */}
        {breadCrumbActive && (
          <li className="flex items-center gap-x-2 shrink-0 pointer-events-none">
            <Breadcrumbs size="16" />
            <span className="text-primaryBlack text-sm md:text-base font-Proxima">
              {breadCrumbActive}
            </span>
          </li>
        )}
      </ul>
    </div>
  );
};

export default Breadcrumb;
